// converts array of platforms from array of strings to array of objects
// because channel multiselect requires data formatted this way
export const convertPlatforms = (platforms) =>
	platforms.map((platform) => ({ name: platform }));

export const convertValueToArray = (value) => (value ? value.split(',') : null);
